/**
 * Pre-auth landing / sign-in. Brand-forward, warm, reassuring.
 * Microsoft (Entra) is the primary CTA; the local-dev button only shows when
 * not hosted on SWA.
 */
import { useI18n } from '../i18n';
import { signIn, isHostedOnSwa } from '../auth/authClient';
import { SunMark } from '../components/Logo';
import { LanguageSwitcher } from '../components/LanguageSwitcher';

export function SignInScreen() {
  const { t, locale } = useI18n();
  const hosted = isHostedOnSwa();

  return (
    <main className="auth-screen">
      <div className="card auth-card">
        <div className="auth-lang">
          <LanguageSwitcher />
        </div>
        <div className="auth-sun">
          <SunMark size={56} />
        </div>
        <h1 style={{ fontSize: '1.6rem' }}>{t.auth.signInTitle}</h1>
        <p className="lead" style={{ margin: '8px 0 24px' }}>
          {t.auth.signInLead}
        </p>

        <div className="stack">
          <button
            type="button"
            className="btn btn-primary btn-block"
            onClick={() => signIn(locale)}
          >
            {hosted ? t.auth.signInMicrosoft : t.auth.signInMock}
          </button>
        </div>

        {!hosted ? (
          <p className="text-xs muted" style={{ marginTop: 16 }}>
            {t.auth.devNotice}
          </p>
        ) : null}

        <p className="text-xs muted" style={{ marginTop: 24 }}>
          {t.tagline}
        </p>
      </div>
    </main>
  );
}
